import { Helmet } from "react-helmet";
import Navbar from "../../../components/Navbar/Navbar";
import WhatsAppWidget from "../../../components/Navbar/Whatsapp";
import Banner from "../../../components/body/projectPageComponents/Banner";
import Overview from "../../../components/body/projectPageComponents/Overview";
import Pricing from "../../../components/body/projectPageComponents/Pricing";
import Gallery from "../../../components/body/projectPageComponents/Gallery";
import Location from "../../../components/body/projectPageComponents/Location";
import Highlights from "../../../components/body/projectPageComponents/Highlights";
import SiteVisitBanner from "../../../components/body/projectPageComponents/SiteVisitBanner";
import FloorPlans from "../../../components/body/projectPageComponents/FloorPlans";
import Amenities from "../../../components/body/projectPageComponents/Amenities";
import Faq from "../../../components/body/projectPageComponents/Faq";
import SimilarProject from "../../../components/body/projectPageComponents/SimilarProject";
import { projectsrahul } from "../../../data/projects/rahul/data";
import Main_Footer from "../../../components/footer/IndiaFooter/Main_Footer";
import { linkifyKeywords } from "../../../utils/linkifyKeywords";

export const Aston = () => {
  const {
    aston: {
      form_data,
      whatsapp,
      bannerdata,
      overview,
      pricing,
      floor_plan,
      highlights,
      location,
      gallery,
      faq,
    },
  } = projectsrahul;

  if (
    !bannerdata ||
    !overview ||
    !pricing ||
    !floor_plan ||
    !highlights ||
    !location ||
    !gallery ||
    !faq
  ) {
    return <div>Loading...</div>; // or an error page, depending on your needs
  }

  const overviewWithLinkedKeywords = {
    ...overview,
    description: overview.description.map((para) =>
      linkifyKeywords(para, overview.keywordLinks)
    ),
  };

  return (
    <>
      <Helmet>
        <title>Rahul Aston Hinjewadi Pune | Luxury Residences</title>
        <meta name="keywords" content="Rahul Aston Hinjewadi Pune" />
        <meta
          name="description"
          content=" Rahul Aston in Hinjewadi, Pune is one of the best residential projects."
        />
        <meta name="author" content="Rahul" />
        <link rel="canonical" href="https://propertystation.in/rahul-aston" />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <WhatsAppWidget whatsappdata={whatsapp} />
      <Navbar />

      <div className="mt-20">
        <Banner
          bannerDesktopImage={bannerdata.bannerDesktopImage}
          bannerMobileImage={bannerdata.bannerMobileImage}
          data={bannerdata.data}
          formData={form_data}
        />
        <Overview
          overviewData={overviewWithLinkedKeywords}
          stripdata={overview.stripdata}
        />
        <SiteVisitBanner formData={form_data} />
        <Pricing pricingData={pricing} formData={form_data} />
        <FloorPlans floorPlans={floor_plan} formData={form_data} />
        <Highlights hightlightData={highlights} formData={form_data} />
        <Amenities />
        <Location location={location} />
        <Gallery galleryData={gallery} />
        <Faq faqdata={faq} />
        {/* <SimilarProject Similarprojects={similar} /> */}
        <Main_Footer />
      </div>
    </>
  );
};
